/*!

=========================================================
* Light Bootstrap Dashboard React - v2.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState, useEffect } from "react";
import { useLocation, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

import { Nav } from "react-bootstrap";

import logo from "assets/img/reactlogo.png";

function Sidebar({ color, image, routes }) {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const activeRoute = (routeName) => {
    return location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };

  // Observer l'ouverture du sidebar
  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          const isOpen = document.documentElement.classList.contains('nav-open');
          if (isOpen) {
            // Délai pour l'animation d'entrée
            setTimeout(() => setIsVisible(true), 150);
          } else {
            setIsVisible(false);
          }
        }
      });
    });

    observer.observe(document.documentElement, { attributes: true });
    return () => observer.disconnect();
  }, []);

  const handleCloseSidebar = () => {
    setIsClosing(true);
    
    // Animation de sortie
    setTimeout(() => {
      setIsVisible(false);
      setIsClosing(false);
      
      if (window.closeSidebarFromBurger) {
        window.closeSidebarFromBurger();
      }
    }, 300);
  };

  return (
    <div className="sidebar" data-image={image} data-color={color}>
      {/* Bouton burger animé dans le sidebar */}
      <button
        className={`sidebar-burger-btn ${isVisible ? 'burger-fly-in' : ''} ${isClosing ? 'burger-fly-out-reverse' : ''}`}
        onClick={handleCloseSidebar}
        style={{
          position: 'absolute',
          top: '15px',
          right: '15px',
          width: '40px',
          height: '40px',
          borderRadius: '50%',
          backgroundColor: '#CE9136',
          border: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          zIndex: 1050,
          opacity: isVisible && !isClosing ? 1 : 0,
          transform: isVisible && !isClosing ? 'scale(1) translateX(0)' : 'scale(0.5) translateX(-100px)',
          transition: 'all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
          boxShadow: '0 2px 10px rgba(0,0,0,0.2)'
        }}
      >
        <X size={20} color="#fff" />
      </button>

      <div className="sidebar-wrapper">
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img
            src={require("../../assets/img/logo_lts.png")}
            alt="Logo"
            className="logo"
          />
        </div>
        <Nav>
          {routes.map((prop, key) => {
            if (!prop.redirect && prop.display)
              return (
                <li
                  className={
                    prop.upgrade
                      ? "active active-pro"
                      : activeRoute(prop.layout + prop.path)
                  }
                  key={key}>
                  <NavLink
                    to={prop.layout + prop.path}
                    className="nav-link"
                    activeClassName="active">
                    {/*  <i className={prop.icon} /> */}
                    <img
                      src={prop.icon}
                      alt={prop.name}
                      className="nav-icon"
                      style={{ height: "26px", marginRight: "10px" }}
                    />
                    <p>{prop.name}</p>
                  </NavLink>
                </li>
              );
            return null;
          })}
        </Nav>
      </div>
    </div>
  );
}

export default Sidebar;
